export const contactKind = {
  normal: 1,
  building: 2
};

export const userType = {
  view: 1,
  maker: 2,
  applyingMaker: 3,
  rejectedMaker: 4,
  admin: 9
};

export const registerKind = {
  create: 1,
  draft: 2
};

export const productStatus = {
  deleted: 0,
  approved: 1,
  draft: 2,
  request: 3,
  changeRequest: 4,
  pastVersion: 8,
  reject: 9
};

export const method = {
  emissionIntensity: 1,
  makerInclude: 2,
  makerPriority: 3
};

export const withdrawList = {
  other: 99
};

export const Co2SettingUseFlg = {
  notUse: 0,
  use: 1
};

export const Co2SettingDefaultFlg = {
  notDefault: 0,
  default: 1
};

export const operatorFlg = {
  notOperator: 0,
  operator: 1
};

export const orderOnGetFavoriteProducts = {
  descCreatedAt: 6
};

export const userStatus = {
  available: 1,
  withdraw: 8,
  inactive: 9
};

export const userRoleEnum = {
  leader: 1,
  member: 2
};

export const withdrawReasonEnum = {
  deletedByLeader: 11,
  deletedInvitationByLeader: 12
};

export const showMessageEnum = {
  show: 1,
  hide: 0
};

export const co2StatuEnum = {
  notset: 0,
  add: 2,
  edit: 3
};
